module.exports = __webpack_public_path__ + "assets/img/en-79d547a8.png";